import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import LeftBarSports from "../../../components/LeftBarSports";
import { LotteryGames } from "../../../../lib/data/LotteryGames.data";
import SearchIcon from "../../../../assets/svg/SearchIcon";
import BackIcon from "../../../../assets/svg/BackIcon";

const Lottery = () => {
  const categoriesTab = [{ name: "Lottery", key: "Lottery" }];
  const [activeCategory, setActiveCategory] = useState("Lottery");
  const [filteredData, setFilteredData] = useState([]);
  const [isSearched, setIsSearched] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  return (
    <>
      <div className="d-md-none">
        <LeftBarSports />
      </div>

      <main className="main">
        <div className="GameHeader">
          <div className="backBtn" onClick={() => navigate(-1)}>
            <BackIcon />
          </div>
          <h4>Lottery</h4>
          <div className="SearchBar">
            <SearchIcon />
          </div>
        </div>
        <div className="container-fluid">
          <div className="casinoProvidersGames">
            <ul className="tabs">
              {categoriesTab.map((tab, index) => (
                <li
                  key={index}
                  onClick={() => {
                    setFilteredData([]);
                    setIsSearched(false);
                    setSearchQuery("");
                    if (tab?.redirectUrl) {
                      navigate(tab?.redirectUrl);
                    } else {
                      setActiveCategory(tab.key);
                    }
                  }}
                  style={activeCategory === tab.key ? {} : {}}
                >
                  <a href="#" style={activeCategory === tab.key ? {} : {}}>
                    {tab.name}
                  </a>
                </li>
              ))}
            </ul>

            {!isSearched ? (
              <ul className="games">
                {Array.isArray(Object.values(LotteryGames)) &&
                  Object.values(LotteryGames)
                    .filter((f) => f?.key === activeCategory)
                    .map((slide) =>
                      Object.values(slide)
                        .filter((f) => typeof f !== "string")
                        .map((game) =>
                          Object.values(game).map((item, idx) => (
                            <li key={"casinogame" + idx}>
                              <a
                                className="play-button"
                                href={item.redirectUrl}
                              >
                                <img src={item.imgUrl} alt={item.name} />
                                <div className="play-btn">
                                  <img src="./images/play-btn.png" alt="play" />
                                </div>
                                <div className="name">{item.name}</div>
                              </a>
                            </li>
                          ))
                        )
                    )}
              </ul>
            ) : (
              <ul className="games">
                {filteredData.length > 0 &&
                  filteredData.map((game, idx) => (
                    <li key={"casinogame" + idx}>
                      <a className="play-button" href={game.redirectUrl}>
                        <img src={game.imgUrl} alt={game.name} />
                        <div className="play-btn">
                          <img src="./images/play-btn.png" alt="play" />
                        </div>
                        <div className="name">{game.name}</div>
                      </a>
                    </li>
                  ))}
              </ul>
            )}
          </div>
        </div>
      </main>
    </>
  );
};

export default Lottery;
